// DS — jeden komunikat w treści (MAPA 07, „Brak systemu” pkt 4; artboard 12).
//
// Cztery tony na tokenach stanu: `danger` (--danger-bg/-fg), `ok` (--ok-bg/-fg),
// `info` (--info-bg/-fg), `warn` (--warn-bg/-fg — limit zaznaczenia, sesja 09); promień --radius-sm; ikona lucide 18 px; 14 px tekstu.
// Zastępuje `AuthNotice` z `components/AuthShell.tsx`, który trzymał tę paletę
// w literałach (G2-auth-onboarding-24), i nadaje się też w aplikacji zamiast `.msg`.
//
// Rola: błąd = `alert` (czytnik przerywa), reszta = `status` (czytnik dopowiada).
// Ikona jest dekoracją — tekst niesie znaczenie, więc `aria-hidden`.

import type { ReactNode } from 'react'
import Icon from '../media/Icon'

export type NoticeTone = 'danger' | 'ok' | 'info' | 'warn'

const ICON: Record<NoticeTone, string> = { danger: 'CircleAlert', ok: 'CircleCheck', info: 'Info', warn: 'TriangleAlert' }

export interface NoticeProps {
  tone?: NoticeTone
  children: ReactNode
  className?: string
  'data-testid'?: string
}

export function Notice({ tone = 'info', children, className = '', ...rest }: NoticeProps) {
  return (
    <div
      className={['notice', `notice-${tone}`, className].filter(Boolean).join(' ')}
      role={tone === 'danger' ? 'alert' : 'status'}
      data-testid={rest['data-testid']}
    >
      <span className="notice-ic" aria-hidden="true"><Icon name={ICON[tone]} size={18} /></span>
      <div className="notice-body">{children}</div>
    </div>
  )
}

export default Notice
